module.exports = __webpack_public_path__ + "static/media/en.0c8987c5.svg";